module.exports = __webpack_public_path__ + "img/a246758.png";